// GateDecideBox.tsx — (TF-6b-4; design §4, planning 10-17 11:25) the Run Inspector's decision for a gate with no screen of its
// own there (lib/gate-map.ts genericDecide: the screenplay, the script or the final of a run with no video page, the covers
// library's curation). Approve, or reject with a note (asked twice: a rejection fails the gate). What the gate is about
// (the screenplay, read-only; the gate's notes) is shown beside it by its caller.
import { useState, type ReactNode } from "react";
import { gateRowOf } from "@/lib/gate-map.ts";

export function GateDecideBox({ stepId, busy, decide, children }: {
  stepId: string; busy: boolean; decide: (approved: boolean, note?: string) => void; children?: ReactNode;
}) {
  const [note, setNote] = useState("");
  const g = gateRowOf(stepId);
  return (
    <div style={{ border: "1px solid var(--tf-border, #e5e7eb)", borderRadius: 8, padding: 12, margin: "10px 0" }}>
      <div style={{ fontWeight: 600 }}>Waiting on you: the {g?.gate ?? stepId} gate</div>
      <div style={{ display: "flex", gap: 16, alignItems: "flex-start", marginTop: 8, flexWrap: "wrap" }}>
        {children && <div style={{ flex: "2 1 360px", minWidth: 0 }}>{children}</div>}
        <div style={{ flex: "1 1 220px" }}>
          <textarea placeholder="A note (needed to reject)" value={note} maxLength={500} rows={3} onChange={(e) => setNote(e.target.value)} style={{ width: "100%" }} />
          <div style={{ display: "flex", gap: 8, marginTop: 6 }}>
            <button disabled={busy} onClick={() => decide(true, note.trim() || undefined)}>Approve</button>
            <button disabled={busy || note.trim().length < 3} onClick={() => {
              if (confirm(`Reject the ${g?.gate ?? stepId} gate? The run stops here.`)) decide(false, note.trim());
            }}>Reject</button>
          </div>
        </div>
      </div>
    </div>
  );
}
